
import { useEffect, useRef, useState } from "react";
import { ExternalLink } from "lucide-react";
import { Button } from "ui/components/button";

export default function SearchResultCard({ result }) {
  const [showFullText, setShowFullText] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const element = contentRef.current;
    if (!element) return;

    const checkOverflow = () => {
      setIsOverflowing(element.scrollHeight > element.clientHeight + 2);
    };
    checkOverflow();

  }, [result.match_reason]);

  const projectId = result.casestudyId;

  return (
    <div className="px-6 py-4 border border-gray-200 rounded-lg">
      <div className="flex justify-between items-start  space-y-3">
        <div className="flex items-center gap-2">
          <h3 className="font-semibold">{result.project_name}</h3>
          <a
            href={projectId ? `/work/projects/${projectId}/basic-details` : "#"}
            target="_blank"
            rel="noopener noreferrer"
            title="View project details"
            className="cursor-pointer"
          >
            <ExternalLink className="h-4 w-4" />
          </a>
        </div>
        <span className="text-green-500 font-semibold">
          {result.matching_score.toFixed(2)}%
        </span>
      </div>

      <div
        ref={contentRef}
        className={`${!showFullText && "max-h-[3em]"} text-sm text-muted-foreground overflow-hidden transition-all duration-1000 ease-in-out`}
      >
        {result.match_reason}
      </div>

      {isOverflowing && (
        <div className="flex justify-end">
          <Button
            variant="link"
            className="text-xs text-primary cursor-pointer underline px-0"
            onClick={() => setShowFullText((prev) => !prev)}
          >
            {showFullText ? "Show Less" : "Show More"}
          </Button>
        </div>
      )}
    </div>
  );
}



export const SearchResults = ({ results, relevancyMessage, relevancyCategory }) => {

  if (!results || results.length === 0) return null;

  return (
    <div className="w-full searchbar mx-auto ">
      <div className="space-y-4 mx-6 mb-10">
        {relevancyCategory && (
          <div className="text-xs font-semibold text-black mb-2">{relevancyCategory}</div>
        )}
        {results.length === 1 && typeof results[0] === 'string' ? (
          <div className="px-6 py-4 border border-gray-200 rounded-lg">
            <p className="text-sm font-normal text-muted-foreground">{results[0]}</p>
          </div>
        ) : (
          [...results].sort((a, b) => b.matching_score - a.matching_score).map((result) => (
            <SearchResultCard key={result.project_id} result={result} />
          ))
        )}
        {relevancyMessage && (
          <div className="text-sm text-gray-700 mb-2">{relevancyMessage}</div>
        )}
      </div>
    </div>
  );
};